var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('div',{staticClass:"mt-2 min-h-57"},[_vm._l((_vm.fundamentals),function(table,index){return _c('b-button',{key:index,staticClass:"mr-2",attrs:{"size":"sm","variant":_vm.selectedTable.id === table.id ? 'primary' : 'outline-primary'},on:{"click":function($event){return _vm.handleSelectTable(table)}}},[_vm._v(" "+_vm._s(table.title)+" ")])}),(_vm.selectedTable && _vm.selectedTable.title)?_c('FundoTable',{attrs:{"hide_table":"","data":{
      indicators: _vm.selectedTable.indicators,
      total: _vm.selectedTable.total,
    }}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }